module.exports = __webpack_public_path__ + "media/images/responsive/icon/icon_pro_certification-4c5c3b78df7e68b66b110dcd2a505a18.svg";